import * as yup from 'yup';

function industryName(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'CREATEFORM_INDUSTRYNAME_FIELD_IS_REQUIRED',
        defaultMessage: 'Industry Name is required',
      }),
    )
    .max(
      32,
      formatMessage({
        id: 'CREATEFORM_INDUSTRYNAME_FIELD_MAX_CHARS_32',
        defaultMessage: 'Industry Name should be less than 32 chars',
      }),
    );
}

function industryCode(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'CREATEFORM_INDUSTRYCODE_FIELD_IS_REQUIRED',
        defaultMessage: 'Industry Code is required',
      }),
    )
    .max(
      32,
      formatMessage({
        id: 'CREATEFORM_INDUSTRYCODE_FIELD_MAX_CHARS_32',
        defaultMessage: 'Industry Code should be less than 32 chars',
      }),
    );
}

function status(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CREATEFORM_STATUS_FIELD_IS_REQUIRED',
      defaultMessage: 'Status is required',
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      industryName: industryName(formatMessage),
      industryCode: industryCode(formatMessage),
      status: status(formatMessage),
    })
    .required();

export default validationSchema;
